import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Layout from "../components/layout/layout";
import "nprogress/nprogress.css";
import NProgress from "nprogress";
import SkeletonLoader from "../components/skeletonLoader/skeleton";
import React, { Suspense, useEffect, startTransition } from "react";
import MainCountryOview from "../Company/MainCountrywrapper";

const Home = React.lazy(() => import("../Home/home"));
const SearchWrapper = React.lazy(() => import("../Search/SearchWrapper"));
const CountryOveViewWrapper = React.lazy(
  () => import("../CountryOverview/CountryOverviewWrapper"),
);

const HomeViewer = React.lazy(() => import("../MiningSite/homeViewer"));
const DocumentWrapper = React.lazy(
  () => import("../Documents/documentWrapper"),
);
const InteractiveCountryMap = React.lazy(
  () => import("../components/country/InteractiveCountryMap"),
);
const DataVisualiztionWrapper = React.lazy(
  () => import("../DataVisualization/datavisualizationWrapper"),
);
const InteractiveMapWrapper = React.lazy(
  () => import("../InteractiveMap/interactivemap"),
);
const CompanyProfileWrapper = React.lazy(
  () => import("../Company/companyWraaper"),
);
const OrganizationMapping = React.lazy(() => import("../Company/OrgChart"));
const RegulationWrapper = React.lazy(
  () => import("../Regulation/regulationWrapper"),
);

const Privacy = React.lazy(() => import("../privacy/privacy"));

const Terms = React.lazy(() => import("../term_of_services/term"));
const RegulationProfile = React.lazy(
  () => import("../Regulation/regulationProfile"),
);
const LicenseWrapper = React.lazy(() => import("../License/LicenseWrapper"));
const InvestigationWrapper = React.lazy(
  () => import("../Investigation/investigationWrapper"),
);
const ReportDetails = React.lazy(
  () => import("../Investigation/reportDetails"),
);
const MineralWrapper = React.lazy(
  () => import("../minieralWrapper/mineralWrapper"),
);
//import MiningSiteWrapper from "../MiningSite/miningSiteWrapper";

const ReportForm = React.lazy(() => import("../Investigation/reportform"));
const AboutPaage = React.lazy(() => import("../about/about"));

const HomeMIneralViewer = React.lazy(
  () => import("../minieralWrapper/homeMineralViewer"),
);

const HomePeopleViewer = React.lazy(() => import("../People/peopleviewer"));
const HomeCompanyViewer = React.lazy(() => import("../Company/homeviewer"));
const NewMineralViewer = React.lazy(
  () => import("../minieralWrapper/new_mineral_page"),
);

const PeopleChartt = React.lazy(() => import("../People/people_organization"));

const MiningSiteWrapper = React.lazy(
  () => import("../MiningSite/miningSiteWrapper"),
);
const BlogDemo = React.lazy(() => import("../Investigation/blogPageWrapper"));

//import PeopleWrapper from "../People/PeopleWrapper";

const PeopleWrapper = React.lazy(() => import("../People/PeopleWrapper"));
const TreeView = React.lazy(() => import("../Company/ExampleMapping"));
const Iframe = React.lazy(() => import("../Company/iframe"));

const RouteWrapper = () => {
  const location = useLocation();
  useEffect(() => {
    NProgress.start();

    const timer = setTimeout(() => {
      NProgress.done();
    }, 300);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <Layout>
      <Suspense fallback={<SkeletonLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<SearchWrapper />} />
          <Route path="/country-overview" element={<CountryOveViewWrapper />} />
          <Route path="/country" element={<MainCountryOview />} />
          <Route path="/map" element={<InteractiveMapWrapper />} />
          <Route path="/company-profile" element={<CompanyProfileWrapper />} />
          <Route
            path="/company/organization-mapping"
            element={<OrganizationMapping />}
          />
          <Route path="/regulation" element={<RegulationWrapper />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/term" element={<Terms />} />

          <Route path="/about" element={<AboutPaage />} />
          <Route path="/regulation/profile" element={<RegulationProfile />} />
          <Route path="/License" element={<LicenseWrapper />} />
          <Route path="/reports" element={<InvestigationWrapper />} />
          <Route path="/reports/details" element={<ReportDetails />} />
          <Route path="/reports/form" element={<ReportForm />} />
          <Route path="/data" element={<DataVisualiztionWrapper />} />
          <Route path="/mining-site" element={<MiningSiteWrapper />} />
          <Route path="/mineral" element={<MineralWrapper />} />
          <Route
            path="/interactive-country"
            element={<InteractiveCountryMap />}
          />

          <Route path="/people" element={<PeopleWrapper />} />
          <Route path="/report/blog" element={<BlogDemo />} />
          <Route path="/tree" element={<TreeView />} />
          <Route path="/iframe" element={<Iframe />} />
          <Route path="/document/view" element={<DocumentWrapper />} />
          <Route path="/site/view" element={<HomeViewer />} />
          <Route path="/mineral/view" element={<HomeMIneralViewer />} />
          <Route path="/people/view" element={<HomePeopleViewer />} />
          <Route path="/companies/view" element={<HomeCompanyViewer />} />

          <Route path="/people/chart" element={<PeopleChartt />} />
          <Route path="/mineral/:mineral" element={<NewMineralViewer />} />
        </Routes>
      </Suspense>
    </Layout>
  );
};

export default RouteWrapper;
